import googleProtobufStructPb from "google-protobuf/google/protobuf/struct_pb.js"

import { frontendProxy } from "../../configs"
import { IntegratedAppsClient } from "../proto/integratedapp_grpc_web_pb"
import { NotifyRequest } from "../proto/integratedapp_pb"

export default class HubspotAPI {
  /**
   * init the Hubspot api
   *
   * @param {string} apiKey - api key
   */
  constructor(apiKey, jwt) {
    if (jwt && apiKey) {
      this.client = new IntegratedAppsClient(frontendProxy)
      this.apiKey = apiKey
      this.jwt = jwt
      this.baseMetadata = {
        authorization: `Bearer ${jwt}`,
        "x-proxy-cluster": "hubspot"
      }
    } else {
      throw new Error("jwt is required")
    }
  }

  /**
   * Notity hubspot api - call to
   * the generic hubspot's endpoint named "notify"
   *
   * @param {string} operationKey - the operation key on hubspot
   * @param {Object} payload - the payload object
   */
  notify(operationKey, payload) {
    // request
    const self = this

    // set notify request
    const request = new NotifyRequest()

    // set operation type
    request.setOperationKey(operationKey)

    // set payload if provided
    if (Object.keys(payload || {}).length) {
      request.setPayload(googleProtobufStructPb.Struct.fromJavaScript(payload))
    }

    // make request -> get notify response object
    return new Promise((resolve, reject) => {
      self.client.notify(request, this.baseMetadata, (err, res) => {
        err ? reject(err) : resolve(res.getPayload().toJavaScript())
      })
    })
  }
}
